<template lang="pug">
  #member-settings
    WtTile(parent)
      WtTile(child)
        BTabs(
          v-model="activeTab"
          expanded
          @input="updateRoute(activeTab)"
          size="is-large"
        )
          BTabItem(v-for="tab in tabs" :key="tab.label" :label="tab.label")
        KeepAlive
          RouterView
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import MemberDevice from "@/views/MemberDevice";
import MemberProfileSettings from "@/views/MemberProfileSettings";
import MemberAccount from "@/views/MemberAccount";
import MemberStepsReminders from "@/views/MemberStepsReminders";
import { tabsMixin } from "../mixins/tabsMixin";

export default {
  name: "MemberSettings",

  components: {
    WtTile,
    WtTitle,
    MemberDevice,
    MemberProfileSettings,
    MemberAccount,
    MemberStepsReminders
  },

  mixins: [tabsMixin],

  data() {
    return {
      tabs: [
        {
          label: "Profile",
          routeName: "MemberProfileSettings"
        },
        {
          label: "Account",
          routeName: "MemberAccount"
        },
        // {
        //   label: "STEPS/REMINDERS",
        //   routeName: "MemberStepsReminders"
        // },
        {
          label: "Devices",
          routeName: "MemberDevice"
        }
      ]
    };
  }
};
</script>

<style lang="sass" scoped>
#member-settings
  .b-tabs.is-fullwidth
    width: calc(100% + 3rem) !important
    margin-left: -$box-padding !important
</style>
